<template>
    <div class="content">
        <userHeader></userHeader>
        <div class="mian">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{
                    path: `/Questions/${this.code}`,
                }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{
                    path: `/Questions/classify/${this.code}`,
                }">列表</el-breadcrumb-item>
                <el-breadcrumb-item>{{ textDetails.albumName }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="dynamic_list">
                <div class="dynamic_list_left">
                    <div class="dynamic_top">
                        <div class="dynamic_top_img">
                            <img :src="setImage(textDetails.image)" @error="handleImageError(textDetails)" alt="">
                        </div>
                        <div class="dynamic_top_info">
                            <div class="dynamic_top_item_one">
                                <div class="dynamic_top_info_tit">{{ textDetails.albumName }}</div>
                                <div class="dynamic_top_info_tits">{{ textDetails.tName }}</div>
                            </div>
                            <div class="dynamic_top_item">
                                <!-- <div class="dynamic_top_info_name" style="width: 190px;" >发布时间：{{setTime(textDetails.updateDate)}}</div> -->
                                <div class="dynamic_top_info_name">章节练习数：{{ textDetails.paperCount }}</div>
                                <!-- <div class="dynamic_top_info_name" style="margin-left: 40px;">访问量：{{textDetails.visitCount}}</div> -->
                            </div>
                            <div class="dynamic_top_item">
                                <div class="dynamic_top_info_name" style="width: 190px;">
                                    真题卷数量：{{ textDetails.truePaperCount }}</div>
                                <div class="dynamic_top_info_name">押题卷数量：{{ textDetails.yaPaperCount }}</div>
                            </div>
                            <div class="dynamic_top_info_introduce" v-if="textDetails.albumInfo">
                                <div class="dynamic_top_info_introduce_tit">介绍：</div>
                                <div class="dynamic_top_info_introduce_info">{{ textDetails.albumInfo }} </div>
                            </div>
                        </div>
                    </div>
                    <div class="dynamic_bottom">
                        <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect"
                            active-text-color="#B81C26" class="dynamic_bottom_menu">
                            <el-menu-item index="3">章节练习</el-menu-item>
                            <el-menu-item index="1">真题卷</el-menu-item>
                            <el-menu-item index="2">押题卷</el-menu-item>
                            <el-menu-item index="4">随机组卷</el-menu-item>
                        </el-menu>
                        <div v-if="activeIndex != 4">
                            <div class="dynamic_bottom_menu_list" v-if="textList && textList.type >= 1">
                                <el-table :data="textList.list" :show-header="false" style="width: 100%">
                                    <el-table-column label="试卷名称" prop="name" :formatter="setTextName">
                                    </el-table-column>
                                    <el-table-column label="操作" width="100">
                                        <template slot-scope="scope">
                                            <el-button type="danger" class="begin_btn" plain
                                                @click="toExam(scope.row)">开始练习</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="dynamic_bottom_menu_list" v-else-if="textList && textList.type == 0">
                                <el-table :data="textList.list" :show-header="false" style="width: 100%" row-key="guid"
                                    default-expand-all :tree-props="{ children: 'paperList' }">
                                    >
                                    <el-table-column label="试卷名称" prop="name" :formatter="setTextName">
                                    </el-table-column>
                                    <el-table-column label="操作" width="100">
                                        <template slot-scope="scope" v-if="!scope.row.paperList">
                                            <el-button type="danger" class="begin_btn" plain
                                                @click="toExam(scope.row)">开始练习</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div v-else>
                            <div class="random_list">
                                <div class="random_list_item">
                                    <div class="random_list_item_left">题型：</div>
                                    <div class="random_list_item_right">
                                        <div class="random_list_item_btn"
                                            :class="needTopicType == '' ? 'random_list_item_select_btn' : ''"
                                            @click="setNeedTopicType('')">
                                            全部
                                        </div>
                                        <div v-for="(items, index) in topicType" :key="items.mark"
                                            class="random_list_item_btn"
                                            :class="needTopicType == items.mark ? 'random_list_item_select_btn' : ''"
                                            @click="setNeedTopicType(items.mark)">
                                            {{ items.value }}
                                        </div>
                                    </div>
                                </div>
                                <div class="random_list_item">
                                    <div class="random_list_item_left">难度：</div>
                                    <div class="random_list_item_right">
                                        <div class="random_list_item_btn"
                                            :class="needTopicDifficultye == '' ? 'random_list_item_select_btn' : ''"
                                            @click="setNeedTopicDifficultye('')">
                                            全部
                                        </div>
                                        <div v-for="(items, index) in topicDifficulty" :key="items.mark"
                                            class="random_list_item_btn"
                                            :class="needTopicDifficultye == items.mark ? 'random_list_item_select_btn' : ''"
                                            @click="setNeedTopicDifficultye(items.mark)">
                                            {{ items.value }}
                                        </div>
                                    </div>
                                </div>
                                <div class="random_list_item">
                                    <div class="random_list_item_left">题目数：</div>
                                    <div class="random_list_item_right">
                                        <div class="random_list_item_btn" @click="needTopicCount(30)"
                                            :class="topicCount == 30 ? 'random_list_item_select_btn' : ''">
                                            小考（30题）
                                        </div>
                                        <div class="random_list_item_btn" @click="needTopicCount(50)"
                                            :class="topicCount == 50 ? 'random_list_item_select_btn' : ''">
                                            标准（50题）
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="random_btn" @click="toRandomExam">
                                开始练习
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dynamic_list_right">
                    <div class="broken">
                    </div>
                    <div class="right_tit">
                        相关推荐
                    </div>
                    <div class="right_practice_test">
                        <div class="practice_test_item" @click="toExam(items)" v-for="(items, index) in recommendLIst">
                            <div class="item_ornament">
                                {{ '0' + (index + 1) }}
                            </div>
                            <div class="item_name">
                                {{ items.name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="float_btns">
                <div class="float_btn" @click="upvote">
                    <img src="https://cdn.zwzlv.com/sykjcloud/2023-07-18/66c29ae9227540f1946a02cad93945fd.png" alt="">
                    点赞
                </div>
                <div class="float_btn" @click="share">
                    <img src="https://cdn.zwzlv.com/sykjcloud/2023-07-10/940a88e90b7444ff92481c149f2df320.png" alt="">
                    分享
                </div>
                <div class="float_btn" @click="collect">
                    <img v-if="!collectFlag"
                        src="https://cdn.zwzlv.com/sykjcloud/2023-07-14/04b427dc53f04e1eb2befd52e1d27da5.png" alt="">
                    <img v-else src="https://cdn.zwzlv.com/sykjcloud/2023-07-14/d00ba59efd9341e4841ca5f1c76d9d83.png"
                        alt="">
                    收藏
                </div>
            </div>
        </div>
        <userFooter></userFooter>
    </div>
</template>
<script>
import userFooter from "@/views/footer";
import userHeader from "@/views/header/levelIndex";
import Cookies from 'js-cookie';
import { TOOLS } from '@/utils/public.js';
import {
    getLogin, getCustSite, getControl, getPracticeTestList, getDetails, getTextList, addVisit,
    getRandomTopic, addCollectionAlbum, addupvote, getRandomCondition, getCollectionAlbum, upDataCollectionAlbum
} from '@/api/api';
import without from '@/assets/image/without.jpg'
export default {
    components: {
        userHeader,
        userFooter,
    },
    data() {
        return {
            TOOLS: TOOLS,
            typeId: '',
            albumId: '',
            recommendLIst: [],
            textDetails: {},
            activeIndex: '3',
            textList: {},
            code: '',
            topicDifficulty: [],
            topicType: [],
            needTopicType: '',
            needTopicDifficultye: '',
            topicCount: 30,
            collectFlag: 0,
            unlogin: false,
        }
    },
    mounted() {
        this.code = this.$route.params.code;
        this.token = Cookies.get('token') ? Cookies.get('token') : '';
        this.albumId = this.$route.query.albumId
        this.typeId = this.$route.query.typeId
        // if (this.$route.query.type) {
        //     this.activeIndex = this.$route.query.type + '';
        // }
        this.verification();
        this.getPracticeTestList();
        this.getTextList();
        this.getDetails();
        this.getRandomTopic();
    },
    methods: {
        // 默认请求这个三接口
        verification() {
            const params = {
                token: this.token,
                cCode: this.code,
                configId: '',
                signature: '',
                configId: "",
                count: 0,
                enable: false,
                info: false,
                mobile: false,
                oType: 0,
                pageId: 26,
                parentId: 0,
                signature: "",
                userId: "",
            }
            getLogin(params).then(res => {
                if (res.status) {
                    if (!res.result.uType) {
                        this.unlogin = true
                    }
                }
            })
            getCustSite(params).then(res => {

            })
            getControl(params).then(res => {

            })
        },
        // 
        getPracticeTestList() {
            const params = {
                token: this.token,
                cCode: this.code,
                configId: '',
                signature: '',
                configId: "",
                count: 8,
                sort: 0,
                typeId: this.typeId,
                mobile: false,
                order: 5,
                oType: 0,
                pageId: 26,
                signature: "",
                userId: "",
            }
            getPracticeTestList(params).then(res => {
                if (res.status) {
                    this.recommendLIst = res.result;
                }
            })
        },
        getDetails() {
            const params = {
                albumId: this.albumId,//专辑ID
                token: this.token,//
                cCode: this.code,//
                mobile: true,//是否是⼿机
                configId: "",//微信配置id，post⾃动传递、get⼿动添加
                signature: "",//免登陆签名
                userId: "",//⽤户Id
                prodAlbumId: ""//免登录专辑
            }
            getDetails(params).then(res => {
                if (res.status) {
                    let index = this.$route.query.type + ''
                    if (index) {
                        if (index == 1 && res.result.truePaperCount > 0) {
                            this.activeIndex = '1'
                            this.getTextList();
                        } else if (index == 2 && res.result.yaPaperCount > 0) {
                            this.activeIndex = '2'
                            this.getTextList();
                        } else if (index == 3 && res.result.paperCount > 0) {
                            this.activeIndex = '3'
                        } else if (res.result.paperCount > 0) {
                            this.activeIndex = '3'
                        } else if (res.result.truePaperCount > 0) {
                            this.activeIndex = '1'
                            this.getTextList();
                        } else if (res.result.yaPaperCount > 0) {
                            this.activeIndex = '2'
                            this.getTextList();
                        } else {
                            this.activeIndex = '3'
                        }
                    } else {
                        if (res.result.paperCount > 0) {
                            this.activeIndex = '3'
                        } else if (res.result.truePaperCount > 0) {
                            this.activeIndex = '1'
                            this.getTextList();
                        } else if (res.result.yaPaperCount > 0) {
                            this.activeIndex = '2'
                            this.getTextList();
                        } else {
                            this.activeIndex = '3'
                        }
                    }

                    this.textDetails = res.result;
                    this.getCollect();
                    this.addVisit();
                }

            })
        },
        getRandomTopic() {
            const params = {
                cCode: this.code,
                token: this.token,
                mobile: false,
                configId: "",
                signature: "",
                userId: "",
                albumId: this.albumId,
            }
            getRandomCondition(params).then(res => {
                if (res.status) {
                    const { topicDifficulty, topicType } = res.result;
                    this.topicDifficulty = topicDifficulty;
                    this.topicType = topicType;
                }
            })
        },

        handleSelect(key, keyPath) {
            this.activeIndex = key
            this.getTextList();
        },
        getTextList() {
            const params = {
                albumId: this.albumId,//专辑ID
                paperType: this.activeIndex,//试卷类型
                token: this.token,
                cCode: this.code,
                mobile: true,//是否是⼿机
                configId: "",//微信配置id，post⾃动传递、get⼿动添加
                signature: "",//免登陆签名
                userId: "",//⽤户Id
                prodAlbumId: ""//免登录专辑
            }
            getTextList(params).then(res => {
                if (res.status) {
                    this.textList = res.result;
                }

            })
        },
        setTextName(row) {
            return '·' + row.name;
        },
        toExam(item) {
            console.log(item)
            this.$router.push({
                path: `/Questions/exam/${this.code}`,
                query: {
                    guid: item.guid,
                }
            })
        },
        toRandomExam() {
            this.$router.push({
                path: `/Questions/randomExam/${this.code}`,
                query: {
                    albumId: this.albumId,//专辑ID
                    needTopicType: this.needTopicType,
                    needTopicDifficultye: this.needTopicDifficultye,
                    topicCount: this.topicCount,
                }
            })
        },
        // 图片加载出错替换为出错提示图片
        handleImageError(item) {
            item.image = without
        },
        // 设置图片的完整路径
        setImage(imgUrl) {
            let pattern = /https:\/\/|http:\/\//;
            if (!imgUrl) {
                return this.TOOLS.fileUtil + '/' + imgUrl;
            } else if (pattern.test(imgUrl)) {
                return imgUrl;
            } else if (imgUrl.includes("/without.")) {
                return imgUrl;
            } else {
                return this.TOOLS.fileUtil + imgUrl;
            }
        },
        // 设置时间为年月日
        setTime(time) {
            if (time) {
                return time.substring(0, 10)
            }
        },
        addVisit() {
            const params = {
                dataId: this.albumId,
                dType: 0,
                openType: 1,
                token: this.token,
                cCode: this.code,
                mobile: false,
                configId: "",
                signature: "",
                userId: "",
                prodAlbumId: this.textDetails.prodId,
            }
            addVisit(params).then(res => {
            })
        },
        // 点赞
        upvote() {
            if (this.unlogin) {
                this.$confirm('您还没有登录，请先登录', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({
                        path: `/Questions/login/${this.code}`
                    })
                })
                return
            }
            const params = {
                token: this.token,
                cCode: this.code,
                mobile: false,
                configId: "",
                signature: "",
                dataId: this.textDetails.prodId,
                prodAlbumId: this.textDetails.prodId,
                openType: 1,

            }
            addupvote(params).then(res => {
                if (res.status) {
                    console.log(res, '====================')
                    this.$message({
                        message: "点赞成功",
                        type: "success"
                    });
                }
            })
        },
        // 分享
        share() {
            let tempInput = document.createElement('input');
            tempInput.value = window.location.href;
            document.body.appendChild(tempInput);
            tempInput.select();
            // 复制文本框中的内容到剪贴板
            document.execCommand('copy');
            this.$message({
                message: "复制成功",
                type: "success"
            });
            tempInput.remove();
        },
        getCollect() {
            console.log(this.textDetails)
            const params = {
                token: this.token,
                cCode: this.code,
                mobile: false,
                configId: "",
                signature: "",
                pGuid: this.textDetails.prodId,
            }
            getCollectionAlbum(params).then(res => {
                if (res.status) {
                    console.log(res, '====================')
                    this.collectFlag = res.result;
                }
            })
        },
        // 收藏
        collect() {
            if (this.unlogin) {
                this.$confirm('您还没有登录，请先登录', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({
                        path: `/Questions/login/${this.code}`
                    })
                })
                return
            }
            if (!this.collectFlag) {

                const params = {
                    token: this.token,
                    cCode: this.code,
                    mobile: false,
                    configId: "",
                    signature: "",
                    pGuid: this.textDetails.prodId,
                }
                addCollectionAlbum(params).then(res => {
                    if (res.status) {
                        this.$message({
                            message: "收藏成功",
                            type: "success"
                        });
                        this.collectFlag = 1;
                    } else {
                        this.$message({
                            message: res.message,
                            type: "warning"
                        })
                    }
                })
            } else {
                const params = {
                    token: this.token,
                    cCode: this.code,
                    mobile: false,
                    configId: "",
                    signature: "",
                    pGuid: this.textDetails.prodId,
                }
                upDataCollectionAlbum(params).then(res => {
                    if (res.status) {
                        this.collectFlag = 0;
                    }
                })
            }

        },     // 需要的题目类型
        setNeedTopicType(row) {
            this.needTopicType = row;
        },
        // 需要的难度
        setNeedTopicDifficultye(row) {
            this.needTopicDifficultye = row;
        },
        // 需要的题目数
        needTopicCount(row) {
            this.topicCount = row;
        },

    }
}
</script>
<style lang="scss" scoped>
.content {
    background: #eff1f4;

    .mian {
        padding-top: 20px;
        margin: 0 auto;
        width: 1520px;

        .dynamic_list {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;

            .dynamic_list_left {
                width: 1134px;
                border-radius: 10px;
                background: #FFFFFF;
                margin-bottom: 10px;

                .dynamic_top {
                    padding: 30px 0px 20px;
                    display: flex;

                    .dynamic_top_img {
                        margin-left: 30px;

                        img {
                            width: 510px;
                            height: 287px;
                            border-radius: 16.14px;
                        }
                    }

                    .dynamic_top_info {
                        margin: 0 20px;
                        width: 554px;

                        .dynamic_top_info_tit {
                            font-family: Source Han Sans CN;
                            font-size: 22px;
                            font-weight: 500;
                            letter-spacing: 0em;
                            color: #B81C26;
                        }

                        .dynamic_top_info_tits {
                            font-family: Source Han Sans CN;
                            font-size: 16px;
                            font-weight: normal;
                            text-align: right;
                            letter-spacing: 0em;
                            color: #8A8A8A;
                        }

                        .dynamic_top_info_name {
                            font-family: Source Han Sans CN;
                            font-size: 14px;
                            font-weight: normal;
                            letter-spacing: 0em;
                            color: #8A8A8A;
                        }

                        .dynamic_top_info_introduce {
                            // display: -webkit-box;
                            // text-overflow: ellipsis; /* 表示超出部分显示省略号；*/
                            // overflow: hidden; /*表示隐藏内容超出容器大小的部分；*/
                            // -webkit-box-orient: vertical;
                            // -webkit-line-clamp: 7; /*属性值为7，表示超出7行隐藏*/
                            // height: 170px;
                            // overflow: auto;
                        }

                        .dynamic_top_info_introduce_tit {
                            font-family: Source Han Sans CN;
                            font-size: 16px;
                            font-weight: normal;
                            text-align: justify;
                            /* 浏览器可能不支持 */
                            letter-spacing: 0em;
                            color: #28303F;
                        }

                        .dynamic_top_info_introduce_info {
                            padding-right: 5px;
                            font-family: Source Han Sans CN;
                            font-size: 14px;
                            font-weight: normal;
                            text-align: justify;
                            /* 浏览器可能不支持 */
                            letter-spacing: 0em;
                            color: #9E9E9E;
                            text-indent: 2em;
                            height: 150px;
                            overflow: auto;
                        }

                        .dynamic_top_info_introduce_info::-webkit-scrollbar {
                            width: 5px;
                            /* 设置滚动条的宽度 */
                            padding-right: 5px;
                        }

                        /* 修改滚动条的轨道样式 */
                        .dynamic_top_info_introduce_info::-webkit-scrollbar-track {
                            background-color: transparent;
                            /* 设置轨道的背景色 */
                        }

                        /* 修改滚动条的滑块样式 */
                        .dynamic_top_info_introduce_info::-webkit-scrollbar-thumb {
                            background: #FFF3EF;
                            /* 设置滑块的背景色 */
                            border-radius: 50px;
                            /* 设置滑块的圆角 */
                        }

                        /* 修改滚动条两端的按钮样式 */
                        .dynamic_top_info_introduce_info::-webkit-scrollbar-button {
                            display: none;
                            /* 隐藏滚动条的按钮 */
                        }

                        .dynamic_top_item_one {
                            display: flex;
                            justify-content: space-between;
                            align-items: end;
                            margin: 12px 0px;
                        }

                        .dynamic_top_item {
                            display: flex;
                            margin-bottom: 8px;
                        }

                    }
                }

                .dynamic_bottom {
                    .dynamic_bottom_menu {
                        ::v-deep .el-menu--horizontal>.el-menu-item.is-active {
                            border-bottom: 4px solid;
                            font-weight: 500;
                        }

                        ::v-deep .el-dropdown-menu__item,
                        .el-menu-item {
                            font-family: Source Han Sans CN;
                            font-size: 18px;
                            font-weight: normal;
                            text-align: center;
                            letter-spacing: 0em;
                            color: #8A8A8A;
                            margin: 0 30px;
                            padding: 0px;
                        }
                    }

                    .dynamic_bottom_menu_list {
                        padding: 0px 25px 0px 30px;
                        margin-bottom: 20px;
                        max-height: 480px;
                        overflow: auto;
                        box-sizing: border-box;
                        margin-right: 5px;

                        ::v-deep .el-table .cell {
                            font-family: Source Han Sans CN;
                            font-size: 14px;
                            font-weight: 500;
                            letter-spacing: 0em;
                            color: #28303F;
                        }

                        ::v-deep .el-table .el-table__cell {
                            padding: 0px;
                            height: 48px;
                        }

                        ::v-deep .el-table td.el-table__cell,
                        .el-table th.el-table__cell.is-leaf {
                            border-bottom: 1px dashed #DFDFDF;
                        }

                        ::v-deep .el-table--border::after,
                        .el-table--group::after,
                        .el-table::before {
                            content: '';
                            position: absolute;
                            /* background-color: #EBEEF5; */
                            z-index: 1;
                        }

                        .begin_btn {
                            width: 76px;
                            height: 29px;
                            border-radius: 4px;
                        }

                        ::v-deep .el-button--danger.is-plain {
                            color: #B81C26;
                            background: #FFFFFF;
                            border-color: #B81C26;
                        }

                        ::v-deep .el-button--danger.is-plain:focus,
                        .el-button--danger.is-plain:hover {
                            background: #B81C26;
                            border-color: #B81C26;
                            color: #FFF;
                        }

                        ::v-deep .el-button {
                            padding: 0px;
                        }
                    }

                    .dynamic_bottom_menu_list::-webkit-scrollbar {
                        width: 5px;
                        /* 设置滚动条的宽度 */
                        padding-right: 5px;
                    }

                    /* 修改滚动条的轨道样式 */
                    .dynamic_bottom_menu_list::-webkit-scrollbar-track {
                        background-color: transparent;
                        /* 设置轨道的背景色 */
                    }

                    /* 修改滚动条的滑块样式 */
                    .dynamic_bottom_menu_list::-webkit-scrollbar-thumb {
                        background: #FFF3EF;
                        /* 设置滑块的背景色 */
                        border-radius: 50px;
                        /* 设置滑块的圆角 */
                    }

                    /* 修改滚动条两端的按钮样式 */
                    .dynamic_bottom_menu_list::-webkit-scrollbar-button {
                        display: none;
                        /* 隐藏滚动条的按钮 */
                    }

                    .random_list {
                        margin: 16px 0px 0px 30px;

                        .random_list_item {
                            margin-bottom: 20px;
                            overflow: hidden;

                            .random_list_item_left {
                                float: left;
                                width: 56px;
                                height: 25px;
                                line-height: 25px;
                                font-size: 14px;
                                font-weight: normal;
                                color: #28303F;
                                text-align: end
                            }

                            .random_list_item_right {
                                display: flex;
                                flex-wrap: wrap;
                                gap: 18px;
                                margin-left: 10px;

                                .random_list_item_btn {
                                    font-size: 14px;
                                    font-weight: normal;
                                    color: #8A8A8A;
                                    padding: 2px 20px;
                                    border-radius: 4px;
                                    border: 1px solid #8A8A8A;
                                    cursor: pointer;
                                }

                                .random_list_item_select_btn {
                                    background: #B81C26;
                                    border: none;
                                    color: #FFFFFF;
                                }
                            }
                        }
                    }

                    .random_btn {
                        width: 316px;
                        height: 58px;
                        border-radius: 10px;
                        background: #FFF3EF;
                        margin: 0 auto;
                        margin-top: 128px;
                        font-size: 18px;
                        font-weight: normal;
                        color: #28303F;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }
                }
            }

            .dynamic_list_right {
                width: 356px;
                height: 724px;
                background: linear-gradient(180deg, #FFF3EE 0%, #FFFFFF 30%);
                box-sizing: border-box;
                border-radius: 10px;
                border: 2px solid rgba(255, 255, 255, 0.8);
                position: relative;
                box-sizing: border-box;
                padding: 0 20px;
                margin-bottom: 38px;

                .broken {
                    position: absolute;
                    top: -4px;
                    right: -4px;
                    width: 0;
                    height: 0;
                    border-left: 25px solid #FFFFFF;
                    border-top: 25px solid #eff1f4;
                    border-bottom: 25px solid #FFFFFF;
                    border-right: 25px solid #eff1f4;
                    border-bottom-left-radius: 10px;
                    border-top-left-radius: 2px;
                    border-bottom-right-radius: 2px;
                    box-shadow: -1px 1px 1px rgba(0, 0, 0, 0.1);
                }

                .right_tit {
                    font-family: Source Han Sans CN;
                    font-size: 30px;
                    font-weight: 500;
                    letter-spacing: 0em;
                    color: #28303F;
                    margin-top: 30px;
                }

                .right_practice_test {
                    margin-top: 20px;
                    overflow: hidden;

                    .practice_test_item {
                        margin-top: 12px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        .item_ornament {
                            font-family: DIN;
                            font-size: 40px;
                            font-weight: bold;
                            letter-spacing: -0.03em;
                            color: #D9D7D8;
                        }

                        .item_name {
                            font-family: Source Han Sans CN;
                            font-size: 18px;
                            font-weight: normal;
                            line-height: 32px;
                            text-align: justify;
                            /* 浏览器可能不支持 */
                            letter-spacing: 0em;
                            /* 文字主色 */
                            color: #28303F;
                            box-sizing: border-box;
                            margin-left: 14px;
                            display: -webkit-box;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2; //当属性值为3，表示超出3行隐藏

                        }
                    }

                    .practice_test_item:nth-child(1) .item_ornament {
                        margin-top: 0px;
                        background: linear-gradient(180deg, #FF3A04 0%, #FF8B3D 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        background-clip: text;
                        text-fill-color: transparent;
                    }

                    .practice_test_item:nth-child(2) .item_ornament {
                        background: linear-gradient(180deg, #2AC788 0%, #4BE288 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        background-clip: text;
                        text-fill-color: transparent;
                    }

                    .practice_test_item:nth-child(3) .item_ornament {
                        background: linear-gradient(180deg, #3782FD 0%, #A8CAFF 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        background-clip: text;
                        text-fill-color: transparent;
                    }
                }
            }
        }

        .float_btns {
            position: fixed;
            right: 50px;
            bottom: 240px;

            .float_btn {
                width: 107px;
                height: 44px;
                border-radius: 165px;
                background: #B81C26;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 20px;
                color: #FFFFFF;
                cursor: pointer;

                img {
                    margin-right: 5px;
                    width: 20px;
                    height: 20px;
                }
            }
        }

    }

    @media screen and (max-width: 1680px) and (min-width: 1366px) {
        .mian {
            width: 1140px !important;

            .dynamic_list {
                .dynamic_list_left {
                    width: 776px !important;

                    .dynamic_top {
                        flex-direction: column;
                        justify-content: center;

                        .dynamic_top_img {
                            margin: 0 auto;
                        }

                        .dynamic_top_info {
                            margin: 0 auto;
                        }
                    }
                }

                // .dynamic_list_right{
                //     display: none;
                // }
            }

        }
    }
}
</style>